
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import store from '@/store/store';

// 获取系统前缀；withSpace 不传按语种，false 全语种无空格，true 强制有空格
export function setConfigCharacters(withSpace) {
  const code = (localStorage.getItem('pageConfig') ?
    JSON.parse(localStorage.getItem('pageConfig'))?.scode : store.state.pageConfig?.scode) || '';
  if (withSpace === false) return code;
  if (withSpace === true) return `${code} `;
  const isZh = (localStorage.getItem('setLanguages') || 'zh-CN') === 'zh-CN';
  return isZh ? code : `${code} `;
}

// listing inputType
export const LISTING_INPUT_TYPE = [
  {value: '1', label: 'text'},
  {value: '2', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000394')},
  {value: '3', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001724')},
  {value: '4', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000395')},
  {value: '5', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001725')}
];

// 规则是否类型
export const RULE_TYPE_IS = [
  'order-service-A044', 'order-service-A045', 'order-service-A042', 'order-service-A040', 'order-service-A035',
  'order-service-A036', 'order-service-A037', 'order-service-A038', 'order-service-A047', 'order-service-A048',
  'order-service-A046', 'CORE-YCCR-045', 'DISTRIBUTOR-DCCR-A024', 'DISTRIBUTOR-DWCR-A024', 'DISTRIBUTOR-DCCR-A028',
  'DISTRIBUTOR-DWCR-A028'
];

// 规则单个input 类型
export const RULE_TYPE_INPUT = [
  'CORE-YCCR-003', 'CORE-YCCR-004', 'DISTRIBUTOR-DCCR-A005', 'DISTRIBUTOR-DWCR-A005',
  'DISTRIBUTOR-DCCR-A004', 'DISTRIBUTOR-DWCR-A004'
];

// 规则 两个checkbox input 类型
export const RULE_TYPE_TCI = [
  'CORE-YCCR-014', 'CORE-YCCR-015', 'CORE-YCCR-016', 'CORE-YCCR-017', 'CORE-YCCR-018', 'CORE-YCCR-019',
  'CORE-YPDR-008', 'CORE-YPDR-006', 'CORE-YPDR-009', 'CORE-YCCR-010', 'CORE-YCCR-013', 'DISTRIBUTOR-DCCR-A012',
  'DISTRIBUTOR-DCCR-A016', 'DISTRIBUTOR-DWCR-A016', 'DISTRIBUTOR-DCCR-A017', 'DISTRIBUTOR-DWCR-A017',
  'DISTRIBUTOR-DCCR-A018', 'DISTRIBUTOR-DWCR-A018', 'DISTRIBUTOR-DCCR-A019', 'DISTRIBUTOR-DWCR-A019',
  'DISTRIBUTOR-DCCR-A020', 'DISTRIBUTOR-DWCR-A020', 'DISTRIBUTOR-DCCR-A021', 'DISTRIBUTOR-DWCR-A021',
  'DISTRIBUTOR-DCCR-A022', 'DISTRIBUTOR-DWCR-A022', 'DISTRIBUTOR-DWCR-A012'
];

// 启用停用状态
export const ENABLEDISABLESTATUS = [
  {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
  {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
  {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
];

// 语种对应
export const mappingLang = {
  EN: 'usName',  // 英文
  FRA: 'frName', // 法文
  GER: 'deName', // 德文
  SPN: 'esName', //西班牙
  NL: 'nlName',  // 荷兰语
  PLN: 'plName', // 波兰
  PT: 'ptName',  // 葡萄牙
  IT: 'itName',  // 意大利
  CN: 'cnName'   // 中文
};
// 规格属性名多语种映射
export const MAPPINGLANGNAME = {
  'en-US': 'usName',
  FRA: 'frName',
  GER: 'deName',
  SPN: 'esName',
  NL: 'nlName',
  PLN: 'plName',
  PT: 'ptName',
  IT: 'itName',
  'zh-CN': 'cnName'
};
// 规格属性值多语种映射
export const MAPPINGLANGVALUE = {
  'en-US': 'usValue',
  FRA: 'frValue',
  GER: 'deValue',
  SPN: 'esValue',
  NL: 'nlValue',
  PLN: 'plValue',
  PT: 'ptValue',
  IT: 'itValue',
  'zh-CN': 'cnValue'
};

// 帮助中心首页视频展示配置
export const HELP_HOME_VIDEOS = {
  yms: [
    {id: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001726'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001727'), bottomDesc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001728'), bgIndex: 0},
    {id: 6, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001726'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001729'), bottomDesc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001730'), bgIndex: 1},
    {id: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001726'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001731'), bottomDesc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001731'), bgIndex: 2},
    {id: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001726'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001732'), bottomDesc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001732'), bgIndex: 3},
  ],
  trs: [
    {id: 1, title: 'TRS', desc: 'Step One Creat Account', bottomDesc: 'Step One Creat Account', bgIndex: 0},
    {id: 2, title: 'TRS', desc: 'Step Two Search Parts', bottomDesc: 'Step Two Search Parts', bgIndex: 1},
    {id: 3, title: 'TRS', desc: 'Step Three Select Parts', bottomDesc: 'Step Three Select Parts', bgIndex: 2},
    {id: 4, title: 'TRS', desc: 'Step Four Prepare Order', bottomDesc: 'Step Four Prepare Order', bgIndex: 3},
    {id: 5, title: 'TRS', desc: 'Step Five Shipping Status', bottomDesc: 'Step Five Shipping Status', bgIndex: 4},
  ],
};

// 按系统环境返回首页视频列表
export function getHelpHomeVideos(env = 'yms') {
  return HELP_HOME_VIDEOS[env] || HELP_HOME_VIDEOS.yms;
}

// 多语种名称
export const MULTILINGUALNAMESLIST = {
  'zh-CN': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001733'),
  'en-US': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001734'),
// {type: 'frName', name: '法语'},
// {type: 'deName', name: '德语'},
// {type: 'esName', name: '西班牙语'},
// {type: 'nlName', name: '荷兰语'},
// {type: 'plName', name: '波兰语'},
// {type: 'ptName', name: '葡萄牙语'},
// {type: 'itName', name: '意大利语'}
};

// 消息模板
export const INFORMATIONTYPELIST = [
  {
    value: 1,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001735'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001736'),
    dynamicParamList: [ // 动态参数, name为含义，placeholder为占位符
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001737'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001738')
  },
  {
    value: 2,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001739'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001740'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001741'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001742')
  },
  {
    value: 3,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001743'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001744'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001741'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001745'),
  },
  {
    value: 4,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001746'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001747'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001741'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001748')
  },
  {
    value: 5,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001749'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001750'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001741'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001751')
  },
  {
    value: 6,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001752'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001753'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001741'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001754')
  },
  {
    value: 7,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001755'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001756'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001737'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001757')
  },
  {
    value: 8,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000539'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001758'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001759'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380'), placeholder: 'A'},
      {name: 'SPU/SKU', placeholder: 'B'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001760')
  },
  {
    value: 9,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001761'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001762'),
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001763'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001761'),
    dynamicParamList: [
      {name: 'SPU', placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001764')
  },
  {
    value: 10,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001765'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001766'),
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001767'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001765'),
    dynamicParamList: [
      {name: 'SPU', placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001768')
  },
  {
    value: 11,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001769'),  // 触发条件的文案
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001770'), // 消息类型名称
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001771'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001769'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001772')
  },
  {
    value: 12,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001773'),  // 触发条件的文案
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001774'), // 消息类型名称
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001774'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001773'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'), placeholder: 'A'}
    ],
    messageTemplate: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001714')}<span class="highlight_color">【A】</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001715')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001716')}`
  },
  {
    value: 13,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001776'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001777'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001776'),
    dynamicParamList: [
      {name: 'SPU', placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001778')
  },
  {
    value: 14,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001779'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001780'),
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001779'),
    dynamicParamList: [
      {name: 'SPU', placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001781')
  },
  {
    value: 15,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001782'),
    name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001717')}`,
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001782'),
    dynamicParamList: [
      {name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, placeholder: 'A'}
    ],
    messageTemplate: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001718')}<span class="highlight_color">【A】</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001719')}`
  },
  {
    value: 16,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001783'),  // 触发条件的文案
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001784'), // 消息类型名称
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001785'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001783'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001786'), placeholder: 'A'},
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'), placeholder: 'B'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001787')
  },
  {
    value: 17,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001788'),
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001789'),
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001789'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001788'),
    dynamicParamList: [
      {name: 'SPU', placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001790')
  },
  {
    value: 18,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001791'),  // 触发条件的文案
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001792'), // 消息类型名称
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001792'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001791'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793'), placeholder: 'A'},
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001794'), placeholder: 'B'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001795')
  },
  {
    value: 19,
    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001796'),  // 触发条件的文案
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001797'), // 消息类型名称
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001797'), // 消息的标题
    triggerConditionTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001796'),
    dynamicParamList: [
      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'), placeholder: 'A'}
    ],
    messageTemplate: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001798')
  },
];

// 翻译之后的云卖订单状态(订单轨迹)
export const YMSORDERSTATUSLIST = [
  {sort: 0, value: 'null', key: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
  {sort: 1, value: 0, key: 'createdTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799')},
  {sort: 2, value: 14, key: 'createdTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800')},
  {sort: 3, value: 13, key: 'createdTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001801')},
  {sort: 4, value: 1, key: 'printTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001802')},
  {sort: 5, value: 2, key: 'pickingFinishTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001803')},
  {sort: 6, value: 3, key: 'packingTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001804')},
  {sort: 7, value: 4, key: 'supperBoxedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001805')},
  {sort: 8, value: 5, key: 'despatchTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001806')},
  {sort: 9, value: 11, key: 'allottedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001807')},
  {sort: 10, value: 6, key: 'allottedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808')},
  {sort: 11, value: 7, key: 'pickedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809')},
  {sort: 12, value: 8, key: 'changedLabelTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810')},
  {sort: 13, value: 9, key: 'boxedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001811')},
  {sort: 14, value: 10, key: 'shipedTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001812')},
  {sort: 15, value: 12, key: 'cancelledTime', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
];

export const ATTRIBUTEMULTILINGUALNAME = [
  {key: 'cnName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000429')},
  {key: 'usName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001814')},
  {key: 'ukName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001815')},
  {key: 'auName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001816')},
  {key: 'euName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001817')},
  {key: 'frName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000434')},
  {key: 'deName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000435')},
  {key: 'esName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000436')},
  {key: 'nlName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000437')},
  {key: 'plName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000438')},
  {key: 'ptName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000439')},
  {key: 'itName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000440')},
  {key: 'roName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000441')},
];

export const ATTRIBUTEVALUEDATA = [
  {key: 'cnValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000429')},
  {key: 'usValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001814')},
  {key: 'ukValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001815')},
  {key: 'auValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001816')},
  {key: 'euValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001817')},
  {key: 'frValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000434')},
  {key: 'deValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000435')},
  {key: 'esValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000436')},
  {key: 'nlValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000437')},
  {key: 'plValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000438')},
  {key: 'ptValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000439')},
  {key: 'itValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000440')},
  {key: 'roValue', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000441')},
];

export const PRODUCTTYPES = [
  {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000953'), value: 1},
  {title: 'POD', value: 4},
];

// 无站点的平台
export const NOSITEPLATFORMLIST = [
  'wish', 'joom', '1688', 'aliexpress', 'fruugo', 'ozon', 'shopify', 'temu',
  'walmart', 'aliexpressChoice', 'alibaba', 'temu_choice'
];

// 不支持取消平台订单的平台
export const CANNOTCANCELPLATFORMORDERSLIST = ['emag', 'shopify', 'temu', 'temu_choice', 'tiktok', 'shein'];

// 泰锐森域名
export const TEMURUSSITE = 'https://shop.tarazon.com';

// 按钮布局配置
export const BUTTONLAYOUTCONFIGURATION = [
  {sortNo: 1, paramKey: 'publish', buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001732'), imgIcon: false, mainButtonValue: 1, isItVisible: 1},
  {
    sortNo: 2,
    paramKey: 'customizeMyDesign',
    buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000698'),
    imgIcon: false,
    iconText: true,
    mainButtonValue: 0,
    isItVisible: 1
  },
  {sortNo: 3, paramKey: 'buyNow', buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001818'), imgIcon: false, mainButtonValue: 0, isItVisible: 1},
  {sortNo: 4, paramKey: 'shoppingCart', buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001819'), imgIcon: false, mainButtonValue: 0, isItVisible: 1},
  {sortNo: 5, paramKey: 'masteryCollection', buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001820'), imgIcon: true, mainButtonValue: 0, isItVisible: 1},
  {
    sortNo: 6,
    paramKey: 'sellingMaterials',
    buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001821'),
    imgIcon: false,
    mainButtonValue: 0,
    isItVisible: 1
  },
  {
    sortNo: 7,
    paramKey: 'downloadMaterials',
    buttonName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001822'),
    imgIcon: false,
    mainButtonValue: 0,
    isItVisible: 1
  }
];

export const HELP_CENTER_PLATFORM = {
  'yms': 'ymsCore',
  'supplier': 'ymsSupplier',
  'distributor': 'ymsDistributor',
};

// 第三方仓
export const THIRD_PARTY_WAREHOUSE = [
  {
    carrierCode: "winitoutstore",
    carrierName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001722'),
    apiInterface: "API_WINIT_OUTSTORE",
    logoImg: require('@/assets/images/thirdPartyWarehouse/winitoutstore.png'),
  },
  {
    carrierCode: "miyunoutstore",
    carrierName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001723'),
    apiInterface: "api_miyundgc",
    logoImg: require('@/assets/images/thirdPartyWarehouse/miyunoutstore.png'),
  },
];

// 系统配置项
export const SYSTEMCONFIGDATA = {
  // 运营端配置项
  yms: [
    /*{
      paramValue: '',
      paramKey: 'ymsCurrency',
      name: '运营端初始默认币种',
      description: ''
    },*/
    {
      paramValue: '',
      paramKey: 'enableProductSaleCountrySet',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001823'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001824')
    },
    {
      paramValue: '',
      paramKey: 'enableShowProductTagInMall',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001825'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001826')
    },
    {
      paramValue: '',
      paramKey: 'ymsLogoConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001827'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001828')
    },
    {
      paramValue: '',
      paramKey: 'ymsLanguage',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001829'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001830')
    },
    {
      paramValue: '',
      paramKey: 'platformSettlementPeriodSet',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001831'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001832')
    },
  ],
  // 分销商端配置项
  distributor: [
    {
      paramValue: '',
      paramKey: 'offlinePayment',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001833'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001834')
    },
    {
      paramValue: '',
      paramKey: 'autoCancelOrder',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001835'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001836')
    },
    {
      paramValue: '',
      paramKey: 'distributorPlatformSet',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001837'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001838')
    },
    {
      paramValue: '',
      paramKey: 'onlineBalanceRecharge',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001839'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001840')
    },
    {
      paramValue: '',
      paramKey: 'distributorLogoConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001827'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001841')
    },
    {
      paramValue: '',
      paramKey: 'distributorLanguage',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001842'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001843')
    },
    {
      paramValue: '',
      paramKey: 'mallDetailsPageSettings',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001844'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001845')
    },
    {
      paramValue: '',
      paramKey: 'touristPriceConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001846'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001847')
    },
    {
      paramValue: '',
      paramKey: 'mallRegisterBusinessType',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001848'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001849')
    },
    {
      paramValue: '',
      paramKey: 'platformOrderShippingWarehouseConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001850'),
      description: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001720')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001721')}`
    },
    {
      paramValue: '',
      paramKey: 'mallRightFloatingInfoConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001851'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001852')
    }
  ],
  // 供应商端配置项
  supplier: [
    {
      paramValue: '',
      paramKey: 'suppliePlatformSet',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001853'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001854')
    },
    {
      paramValue: '',
      paramKey: 'supplierLogoConfig',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001827'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001855')
    },
    {
      paramValue: '',
      paramKey: 'supplierLanguage',
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001842'),
      description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001856')
    },
  ]
}

// 履约方式
export const PERFORMANCEMETHODDATA = [
  {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001857')},
  {value: 2, name: 'Tiktok-CBT'}
];

// 云卖获取Saas配置项的key值
export const SAAS_PARAM_KEYS = [
  'languageSetSaas',            // 语种配置
  'distributorPlatformSetSaas', // 分销端跨境电商平台配置
  'onlineBalanceRechargeSaas',  // 分销端在线支付渠道
  'suppliePlatformSetSaas',     // 供应商第三方平台配置
  'productWholesaleModelSaas',  // 商品零售&批发模式配置
  'ymsThreeWarehouseSetSaas',   // 运营端三方仓配置
  'platformSelfOperatedProductModelSaas', // 平台自营商品模式配置
  'orderComplianceLabelVerificationSaas', // 订单合规标签验证配置
];

// 校验当前商户配置项key值
export const VALIDATEMERCHANTCONFIGKEY = [
  // 运营端配置项
  'ymsCurrency',
  'ymsLogoConfig',
  'ymsLanguage',
  // 分销商配置项
  'distributorLanguage',
  'distributorLogoConfig',
  'distributorPlatformSet',
  // 供应商配置项
  'supplierLogoConfig',
  'supplierLanguage',
];

// 在运营系统使用--(配置项存储在运营端) 商户维度的key值
export const YMS_MERCHANT_CONFIG_KEY = [
  'offlinePayment', //  线下支付配置
  'enableProductSaleCountrySet', // 商品可售卖国
  'mallDetailsPageSettings', // 商品详情页按钮布局配置
  'distributorPlatformSet', // 跨境电商平台配置
];

// 在商城、分销系统使用--(配置项存储在运营端) 商户维度的key值
export const MALL_DISTRIBUTOR_CONFIG_KEY = [
  'offlinePayment', //  线下支付配置
  'onlineBalanceRecharge',  // 在线支付渠道配置
  'enableShowProductTagInMall', // 商品标签展示
  'enableProductSaleCountrySet', // 商品可售卖国
  'distributorPlatformSet', // 跨境电商平台配置
  'touristPriceConfig', // 商城游客价格展示配置
  'mallDetailsPageSettings', // 商品详情页按钮布局配置
  'mallRightFloatingInfoConfig', // 商城右侧悬浮信息展示配置
];

// 在供应商系统使用--(配置项存储在运营端) 商户维度的key值
export const SUPPLIER_CONFIG_KEY = [
  'suppliePlatformSet', // 供应商-第三方平台配置
];

// (配置项存储在供应商端) 商户维度的key值
export const USER_SUPPLIER_CONFIG_KEY = [
  'productGoodsFactory', // pod配置
  'collectGoodsConfig', // 配置采集商品
  'goodsCollection', // 供货优先级配置
  'productDefaultOriginalCountryCode', // 商品默认原产地国
];

// (配置项存储在分销商端) 商户维度的key值
export const USER_DISTRIBUTOR_CONFIG_KEY = [
  'distributorInventoryPriority', // 库存优先级配置
];

// 运营、供应商商品详情--批量填充配置映射的字段paramKey值
export const YMS_MERCHANT_CONFIG_KEY_MAP = {
  // 供应商商品
  weight: 'fillWeightConfig', // 重量
  packageDimensions: 'fillpackageDimensionsConfig', // 包装尺寸
  
  // 自营商品
  selfOperatedWeight: 'fillSelfOperatedWeightConfig', // 重量
  selfOperatedPackageDimensions: 'fillSelfOperatedPackageDimensionsConfig', // 包装尺寸
  selfOperatedSupplyPrice: 'fillSelfOperatedSupplyPriceConfig', // 供货价
  selfOperatedProductPriceConfiguration: 'fillSelfOperatedPriceConfig', // 商品价格配置
};

// 运营、供应商商品详情--批量填充配置根据业务key值获取真实列表字段值映射关系
export const PRODUCT_DETAILS_FIELDKEY = {
  // 供应商商品
  packageDimensions: ['length', 'width', 'height'],
  
  // 自营商品
  selfOperatedWeight: ['weight'],
  selfOperatedPackageDimensions: ['length', 'width', 'height'],
  selfOperatedProductPriceConfiguration: [
    'supplier_floatNum',
    'supplier_fixedFloatNum',
    'supplier_serviceFloatNum',
    'supplier_serviceFixedFloatNum',
    
    // 批发模式
    'supplier_wholesale_floatNum',
    'supplier_wholesale_fixedFloatNum',
    'supplier_wholesale_serviceFloatNum',
    'supplier_wholesale_serviceFixedFloatNum',
  ],
}


